import React, {useState} from "react";
import useStore from "../store";
import LangContainer from "./LangContainer";
import strings from "../lang/Localiz";

export default function LangSelector({}) {
    let locale = ["ru", "en", "de", "pl", "fr", "ja", "es", "pt"];
    const setLangStore = useStore(state => state.setLang);
    const langCurrent = useStore(state => state.lang);
    const [showLang, setShowLang] = useState(false);
    const language = new URLSearchParams(window.location.search).get("lang");

    const getLang = new URLSearchParams(window.location.search).get("lang");

    const lang = getLang ? getLang : strings.getLanguage();


    let myIndex = locale.indexOf(langCurrent);

    if (myIndex !== -1) {
         locale.splice(myIndex, 1);
    }


    const dismissPicker = () => {
        if (showLang) {setShowLang(false)}
    }

    React.useLayoutEffect(() => {
        if (language) {
            setLangStore(language);
            localStorage.setItem('lang', language);
        }
    }, [language])

    return (
        <div onClick={() => setShowLang(!showLang)} className={`lang ${lang == 'ru' ? 'disabled' : ''}`}>
            <div className={"flag-lang"}>
                <div className={"flag-lang-active"}>
                    <div className={"fll-icon flag-lang-locale-" + langCurrent}/>
                    <span/>
                </div>
                {
                    showLang &&
                    <LangContainer locale={ locale} dismissPicker={() => dismissPicker()}/>
                }
            </div>
        </div>
    )
}
